module.exports = __webpack_public_path__ + "img/home5.867f7334.png";